import React, { useEffect } from 'react';
import './InsuranceTools.scss';
import Breadcrumb from '../Common/Breadcrumb/Breadcrumb';
import InsuranceCards from './InsuranceCards';
import { NeedsAnalysisList } from '../Helpers/Lists/NeedsAnalysisList';

export default function InsuranceTools(props) {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <div className="breadcrumbs-insurance-tools mb-4">
                <Breadcrumb breadcrumbLinks={[{ name: 'HOME', href: '/' }]} currentPage={'INSURANCE PRODUCTS'} />
            </div>
            {
                NeedsAnalysisList.map((index, i) =>
                    !index.isShowOnlyOnHomePage && <InsuranceCards key={i} cardText={index.name} logo={index.icon} backgroundImage={index.backgroundImage} history={props.history} location={index.href} />
                )
            }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/InsuranceTools/InsuranceTools.js